import { ApiError } from '@libraries/typescript/api_client';

export type AllCaregiversInactiveError = {
    readonly kind: 'all_caregivers_inactive';
};

export type KnownApiError = AllCaregiversInactiveError;

export function parseKnownApiError(error: unknown): KnownApiError | null {
    if (!(error instanceof ApiError)) {
        return null;
    }

    if (error.status === 400) {
        const body = error.body as { detail?: unknown } | undefined;
        const detail = body?.detail;
        if (
            typeof detail === 'string' &&
            detail.startsWith('All selected caregivers are inactive')
        ) {
            return { kind: 'all_caregivers_inactive' };
        }
    }

    return null;
}

/**
 * The backend's plain-string `detail` from a FastAPI HTTPException (409/422/503,
 * etc.), or null when the error isn't a string-detail ApiError. Use to surface
 * the actionable server message instead of a generic toast.
 */
export function getApiErrorDetail(error: unknown): string | null {
    if (!(error instanceof ApiError)) {
        return null;
    }
    const body = error.body as { readonly detail?: unknown } | undefined;
    return typeof body?.detail === 'string' ? body.detail : null;
}
